
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {SymbolGroupModifyResponse} from './SymbolGroupModifyResponse';
import {MarginRateCalculationType} from '../core/MarginRateCalculationType';
import {FieldModelMarginRateCalculationType} from '../core/MarginRateCalculationType';
import {TradingMode} from '../core/TradingMode';
import {FieldModelTradingMode} from '../core/TradingMode';

/**
 * SymbolGroupModifyRequest struct
 */
class SymbolGroupModifyRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {UUID=} symbolGroupId
   * @param {string=} symbolGroupName
   * @param {number=} newSortOrder
   * @param {string=} newName
   * @param {string=} newComment
   * @param {string=} newDescription
   * @param {number=} newColor
   * @param {boolean=} newIsTradeAllowed
   * @param {number=} newDefaultExpiration
   * @param {MarginRateCalculationType=} newMarginRateCalculationType
   * @param {TradingMode=} newDefaultTradingMode
   * @param {string=} newClientName
   * @param {!boolean=} newClientNameReset
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), symbolGroupId = null, symbolGroupName = null, newSortOrder = null, newName = null, newComment = null, newDescription = null, newColor = null, newIsTradeAllowed = null, newDefaultExpiration = null, newMarginRateCalculationType = null, newDefaultTradingMode = null, newClientName = null, newClientNameReset = false) {
    super()
    super.copy(parent)
    this.SymbolGroupId = symbolGroupId
    this.SymbolGroupName = symbolGroupName
    this.NewSortOrder = newSortOrder
    this.NewName = newName
    this.NewComment = newComment
    this.NewDescription = newDescription
    this.NewColor = newColor
    this.NewIsTradeAllowed = newIsTradeAllowed
    this.NewDefaultExpiration = newDefaultExpiration
    this.NewMarginRateCalculationType = newMarginRateCalculationType
    this.NewDefaultTradingMode = newDefaultTradingMode
    this.NewClientName = newClientName
    this.NewClientNameReset = newClientNameReset
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SymbolGroupModifyRequest}
   * @param {!SymbolGroupModifyRequest} other Other struct
   * @returns {!SymbolGroupModifyRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolGroupId != null) {
      this.SymbolGroupId = new UUID(other.SymbolGroupId)
    } else {
      this.SymbolGroupId = null
    }
    if (other.SymbolGroupName != null) {
      this.SymbolGroupName = other.SymbolGroupName
    } else {
      this.SymbolGroupName = null
    }
    if (other.NewSortOrder != null) {
      this.NewSortOrder = other.NewSortOrder
    } else {
      this.NewSortOrder = null
    }
    if (other.NewName != null) {
      this.NewName = other.NewName
    } else {
      this.NewName = null
    }
    if (other.NewComment != null) {
      this.NewComment = other.NewComment
    } else {
      this.NewComment = null
    }
    if (other.NewDescription != null) {
      this.NewDescription = other.NewDescription
    } else {
      this.NewDescription = null
    }
    if (other.NewColor != null) {
      this.NewColor = other.NewColor
    } else {
      this.NewColor = null
    }
    if (other.NewIsTradeAllowed != null) {
      this.NewIsTradeAllowed = other.NewIsTradeAllowed
    } else {
      this.NewIsTradeAllowed = null
    }
    if (other.NewDefaultExpiration != null) {
      this.NewDefaultExpiration = UInt64.fromNumber(other.NewDefaultExpiration)
    } else {
      this.NewDefaultExpiration = null
    }
    if (other.NewMarginRateCalculationType != null) {
      this.NewMarginRateCalculationType = MarginRateCalculationType.fromObject(other.NewMarginRateCalculationType)
    } else {
      this.NewMarginRateCalculationType = null
    }
    if (other.NewDefaultTradingMode != null) {
      this.NewDefaultTradingMode = TradingMode.fromObject(other.NewDefaultTradingMode)
    } else {
      this.NewDefaultTradingMode = null
    }
    if (other.NewClientName != null) {
      this.NewClientName = other.NewClientName
    } else {
      this.NewClientName = null
    }
    if (other.NewClientNameReset != null) {
      this.NewClientNameReset = other.NewClientNameReset
    } else {
      this.NewClientNameReset = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SymbolGroupModifyRequest}
   * @returns {!SymbolGroupModifyRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SymbolGroupModifyRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SymbolGroupModifyRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SymbolGroupModifyRequest}
   * @param {!SymbolGroupModifyRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SymbolGroupModifyRequest)) {
      throw new TypeError('Instance of SymbolGroupModifyRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SymbolGroupModifyRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolGroupId: ((this.SymbolGroupId != null) ? this.SymbolGroupId.toString() : null),
      SymbolGroupName: ((this.SymbolGroupName != null) ? this.SymbolGroupName : null),
      NewSortOrder: ((this.NewSortOrder != null) ? this.NewSortOrder : null),
      NewName: ((this.NewName != null) ? this.NewName : null),
      NewComment: ((this.NewComment != null) ? this.NewComment : null),
      NewDescription: ((this.NewDescription != null) ? this.NewDescription : null),
      NewColor: ((this.NewColor != null) ? this.NewColor : null),
      NewIsTradeAllowed: ((this.NewIsTradeAllowed != null) ? this.NewIsTradeAllowed : null),
      NewDefaultExpiration: ((this.NewDefaultExpiration != null) ? this.NewDefaultExpiration.toNumber() : null),
      NewMarginRateCalculationType: ((this.NewMarginRateCalculationType != null) ? this.NewMarginRateCalculationType : null),
      NewDefaultTradingMode: ((this.NewDefaultTradingMode != null) ? this.NewDefaultTradingMode : null),
      NewClientName: ((this.NewClientName != null) ? this.NewClientName : null),
      NewClientNameReset: ((this.NewClientNameReset != null) ? this.NewClientNameReset : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SymbolGroupModifyRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SymbolGroupModifyRequest} other Object value
   * @returns {!SymbolGroupModifyRequest} Created struct
   */
  static fromObject (other) {
    return new SymbolGroupModifyRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SymbolGroupModifyRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SymbolGroupModifyRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SymbolGroupModifyRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6102
  }
}

export { SymbolGroupModifyRequest };

/**
 * Fast Binary Encoding SymbolGroupModifyRequest field model
 */
class FieldModelSymbolGroupModifyRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.SymbolGroupId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolGroupName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.SymbolGroupId.fbeOffset + this.SymbolGroupId.fbeSize), buffer, this.SymbolGroupId.fbeOffset + this.SymbolGroupId.fbeSize)
    this.NewSortOrder = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.SymbolGroupName.fbeOffset + this.SymbolGroupName.fbeSize), buffer, this.SymbolGroupName.fbeOffset + this.SymbolGroupName.fbeSize)
    this.NewName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize), buffer, this.NewSortOrder.fbeOffset + this.NewSortOrder.fbeSize)
    this.NewComment = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewName.fbeOffset + this.NewName.fbeSize), buffer, this.NewName.fbeOffset + this.NewName.fbeSize)
    this.NewDescription = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize), buffer, this.NewComment.fbeOffset + this.NewComment.fbeSize)
    this.NewColor = new fbe.FieldModelOptional(new fbe.FieldModelUInt32(buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize), buffer, this.NewDescription.fbeOffset + this.NewDescription.fbeSize)
    this.NewIsTradeAllowed = new fbe.FieldModelOptional(new fbe.FieldModelBool(buffer, this.NewColor.fbeOffset + this.NewColor.fbeSize), buffer, this.NewColor.fbeOffset + this.NewColor.fbeSize)
    this.NewDefaultExpiration = new fbe.FieldModelOptional(new fbe.FieldModelUInt64(buffer, this.NewIsTradeAllowed.fbeOffset + this.NewIsTradeAllowed.fbeSize), buffer, this.NewIsTradeAllowed.fbeOffset + this.NewIsTradeAllowed.fbeSize)
    this.NewMarginRateCalculationType = new fbe.FieldModelOptional(new FieldModelMarginRateCalculationType(buffer, this.NewDefaultExpiration.fbeOffset + this.NewDefaultExpiration.fbeSize), buffer, this.NewDefaultExpiration.fbeOffset + this.NewDefaultExpiration.fbeSize)
    this.NewDefaultTradingMode = new fbe.FieldModelOptional(new FieldModelTradingMode(buffer, this.NewMarginRateCalculationType.fbeOffset + this.NewMarginRateCalculationType.fbeSize), buffer, this.NewMarginRateCalculationType.fbeOffset + this.NewMarginRateCalculationType.fbeSize)
    this.NewClientName = new fbe.FieldModelOptional(new fbe.FieldModelString(buffer, this.NewDefaultTradingMode.fbeOffset + this.NewDefaultTradingMode.fbeSize), buffer, this.NewDefaultTradingMode.fbeOffset + this.NewDefaultTradingMode.fbeSize)
    this.NewClientNameReset = new fbe.FieldModelBool(buffer, this.NewClientName.fbeOffset + this.NewClientName.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolGroupId.fbeSize + this.SymbolGroupName.fbeSize + this.NewSortOrder.fbeSize + this.NewName.fbeSize + this.NewComment.fbeSize + this.NewDescription.fbeSize + this.NewColor.fbeSize + this.NewIsTradeAllowed.fbeSize + this.NewDefaultExpiration.fbeSize + this.NewMarginRateCalculationType.fbeSize + this.NewDefaultTradingMode.fbeSize + this.NewClientName.fbeSize + this.NewClientNameReset.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolGroupId.fbeExtra + this.SymbolGroupName.fbeExtra + this.NewSortOrder.fbeExtra + this.NewName.fbeExtra + this.NewComment.fbeExtra + this.NewDescription.fbeExtra + this.NewColor.fbeExtra + this.NewIsTradeAllowed.fbeExtra + this.NewDefaultExpiration.fbeExtra + this.NewMarginRateCalculationType.fbeExtra + this.NewDefaultTradingMode.fbeExtra + this.NewClientName.fbeExtra + this.NewClientNameReset.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSymbolGroupModifyRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6102
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolGroupId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolGroupId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupId.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolGroupName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewSortOrder.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewComment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDescription.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewColor.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewColor.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewColor.fbeSize

    if ((fbeCurrentSize + this.NewIsTradeAllowed.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewIsTradeAllowed.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsTradeAllowed.fbeSize

    if ((fbeCurrentSize + this.NewDefaultExpiration.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDefaultExpiration.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDefaultExpiration.fbeSize

    if ((fbeCurrentSize + this.NewMarginRateCalculationType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewMarginRateCalculationType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMarginRateCalculationType.fbeSize

    if ((fbeCurrentSize + this.NewDefaultTradingMode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewDefaultTradingMode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDefaultTradingMode.fbeSize

    if ((fbeCurrentSize + this.NewClientName.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewClientName.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientName.fbeSize

    if ((fbeCurrentSize + this.NewClientNameReset.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.NewClientNameReset.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientNameReset.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!SymbolGroupModifyRequest} fbeValue Default value, defaults is new SymbolGroupModifyRequest()
   * @returns {!SymbolGroupModifyRequest} SymbolGroupModifyRequest value
   */
  get (fbeValue = new SymbolGroupModifyRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!SymbolGroupModifyRequest} fbeValue SymbolGroupModifyRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolGroupId.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolGroupId = this.SymbolGroupId.get()
    } else {
      fbeValue.SymbolGroupId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupId.fbeSize

    if ((fbeCurrentSize + this.SymbolGroupName.fbeSize) <= fbeStructSize) {
      fbeValue.SymbolGroupName = this.SymbolGroupName.get()
    } else {
      fbeValue.SymbolGroupName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolGroupName.fbeSize

    if ((fbeCurrentSize + this.NewSortOrder.fbeSize) <= fbeStructSize) {
      fbeValue.NewSortOrder = this.NewSortOrder.get()
    } else {
      fbeValue.NewSortOrder = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewSortOrder.fbeSize

    if ((fbeCurrentSize + this.NewName.fbeSize) <= fbeStructSize) {
      fbeValue.NewName = this.NewName.get()
    } else {
      fbeValue.NewName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewName.fbeSize

    if ((fbeCurrentSize + this.NewComment.fbeSize) <= fbeStructSize) {
      fbeValue.NewComment = this.NewComment.get()
    } else {
      fbeValue.NewComment = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewComment.fbeSize

    if ((fbeCurrentSize + this.NewDescription.fbeSize) <= fbeStructSize) {
      fbeValue.NewDescription = this.NewDescription.get()
    } else {
      fbeValue.NewDescription = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDescription.fbeSize

    if ((fbeCurrentSize + this.NewColor.fbeSize) <= fbeStructSize) {
      fbeValue.NewColor = this.NewColor.get()
    } else {
      fbeValue.NewColor = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewColor.fbeSize

    if ((fbeCurrentSize + this.NewIsTradeAllowed.fbeSize) <= fbeStructSize) {
      fbeValue.NewIsTradeAllowed = this.NewIsTradeAllowed.get()
    } else {
      fbeValue.NewIsTradeAllowed = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewIsTradeAllowed.fbeSize

    if ((fbeCurrentSize + this.NewDefaultExpiration.fbeSize) <= fbeStructSize) {
      fbeValue.NewDefaultExpiration = this.NewDefaultExpiration.get()
    } else {
      fbeValue.NewDefaultExpiration = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDefaultExpiration.fbeSize

    if ((fbeCurrentSize + this.NewMarginRateCalculationType.fbeSize) <= fbeStructSize) {
      fbeValue.NewMarginRateCalculationType = this.NewMarginRateCalculationType.get()
    } else {
      fbeValue.NewMarginRateCalculationType = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewMarginRateCalculationType.fbeSize

    if ((fbeCurrentSize + this.NewDefaultTradingMode.fbeSize) <= fbeStructSize) {
      fbeValue.NewDefaultTradingMode = this.NewDefaultTradingMode.get()
    } else {
      fbeValue.NewDefaultTradingMode = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewDefaultTradingMode.fbeSize

    if ((fbeCurrentSize + this.NewClientName.fbeSize) <= fbeStructSize) {
      fbeValue.NewClientName = this.NewClientName.get()
    } else {
      fbeValue.NewClientName = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientName.fbeSize

    if ((fbeCurrentSize + this.NewClientNameReset.fbeSize) <= fbeStructSize) {
      fbeValue.NewClientNameReset = this.NewClientNameReset.get()
    } else {
      fbeValue.NewClientNameReset = false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.NewClientNameReset.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {!SymbolGroupModifyRequest} fbeValue SymbolGroupModifyRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSymbolGroupModifyRequest}
   * @param {SymbolGroupModifyRequest} fbeValue SymbolGroupModifyRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolGroupId.set(fbeValue.SymbolGroupId)
    this.SymbolGroupName.set(fbeValue.SymbolGroupName)
    this.NewSortOrder.set(fbeValue.NewSortOrder)
    this.NewName.set(fbeValue.NewName)
    this.NewComment.set(fbeValue.NewComment)
    this.NewDescription.set(fbeValue.NewDescription)
    this.NewColor.set(fbeValue.NewColor)
    this.NewIsTradeAllowed.set(fbeValue.NewIsTradeAllowed)
    this.NewDefaultExpiration.set(fbeValue.NewDefaultExpiration)
    this.NewMarginRateCalculationType.set(fbeValue.NewMarginRateCalculationType)
    this.NewDefaultTradingMode.set(fbeValue.NewDefaultTradingMode)
    this.NewClientName.set(fbeValue.NewClientName)
    this.NewClientNameReset.set(fbeValue.NewClientNameReset)
  }
}

export { FieldModelSymbolGroupModifyRequest };

/**
 * Fast Binary Encoding SymbolGroupModifyRequest model
 */
class SymbolGroupModifyRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSymbolGroupModifyRequest(this.buffer, 4)
  }

  /**
   * Get the SymbolGroupModifyRequest model
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!FieldModelSymbolGroupModifyRequest} model SymbolGroupModifyRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SymbolGroupModifyRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSymbolGroupModifyRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SymbolGroupModifyRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SymbolGroupModifyRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SymbolGroupModifyRequestModel}
   * @param {!SymbolGroupModifyRequest} value SymbolGroupModifyRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SymbolGroupModifyRequestModel}
   * @param {!SymbolGroupModifyRequest} value SymbolGroupModifyRequest value, defaults is new SymbolGroupModifyRequest()
   * @return {!object} Deserialized SymbolGroupModifyRequest value and its size
   */
  deserialize (value = new SymbolGroupModifyRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SymbolGroupModifyRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SymbolGroupModifyRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SymbolGroupModifyRequestModel}
   * @param {!number} prev Previous SymbolGroupModifyRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SymbolGroupModifyRequestModel };
SymbolGroupModifyRequest.__has_response = true;
SymbolGroupModifyRequest.__response_class = SymbolGroupModifyResponse;
